import {cep, cpfOrCnpj, phone, Schema} from 'simpli-web-sdk'
import AutoCompleteDestinatario from '@/model/resource/AutoCompleteDestinatario'

export default (model: AutoCompleteDestinatario): Schema => ({
    nome: {
        content: model.nome,
    },
    cpfCnpj: {
        content: cpfOrCnpj(model.cpfCnpj),
    },
    telefone: {
        content: phone(model.telefone),
    },
    email: {
        content: model.email,
    },
    logradouro: {
        content: model.logradouro,
    },
    numero: {
        content: model.numero,
    },
    bairro: {
        content: model.bairro,
    },
    cep: {
        content: cep(model.cep),
    },
    cidade: {
        content: model.cidade,
    },
    uf: {
        content: model.uf,
    },
    complemento: {
        content: model.complemento,
    },
})
